import { createMiddleware } from 'redux-beacon';
import logger from '@redux-beacon/logger';
import URL from 'url';

function createAnalyticsMiddleware(target, events) {
  // No tracking on server-side
  if (!process.browser) {
    return function () {
      return function (next) {
        return function (action) {
          return next(action);
        };
      };
    };
  }

  // No tracking in development environment
  if (process.env.NODE_ENV !== 'production') {
    return createMiddleware(events, function () {}, { logger: logger });
  }

  return createMiddleware(events, target);
}

/** @module analytics/maps */

function createMapsExtension(options) {
  var endpointUrlObject = URL.parse(options.endpoint);

  return function (events) {
    if (process.browser) {
      events.forEach(function (event) {
        if (event.btag) {
          var customFields = event.customFields || {};
          var urlObject = Object.assign({}, endpointUrlObject, {
            query: Object.assign({}, customFields, {
              key: options.key,
              reportid: options.reportId,
              playerid: event.playerId,
              btag: event.btag,
              event: event.actionName
            }, event.actionName === 'deposit' ? { deposit: event.deposit.value } : {})
          });
          fetch(URL.format(urlObject), { mode: 'no-cors' });
        }
      });
    }
  };
}

/**
 * Set up Maps analytics middleware
 * @memberof analytics/maps
 * @param {Object} events
 * @param {Object} options
 * @param {string} options.reportId static value exculsive to brand
 * @param {string} options.key static value exculsive to brand
 * @param {string} options.endpoint Host and pathname to fetch pixel from
 * @returns {Function} Redux middleware
 */
function middleware(events, options) {
  return createAnalyticsMiddleware(createMapsExtension(options), events);
}

export { middleware };
